import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { LoaderInterceptor } from './loader.interceptor';
import { BackgroundLoader } from './background-loader.service';

@NgModule({
  imports: [CommonModule],
  declarations: [],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    BackgroundLoader,
  ]
})
export class InterceptorsModule {}
